import { Injectable, Pipe } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ContactModel } from '../models/contact.model';
import { OrganizationModel } from '../models/organization.model';

@Pipe({ name: 'OrganizationService' })
@Injectable()
export class OrganizationService {

  constructor(private httpClient: HttpClient) { }

  getAllOrganization() {
    let url = localStorage.getItem('ApiEndPoint') + "/api/organization/getAllOrganization";
    return this.httpClient.post(url, {})
      .map((response: Response) => {
        return response;
      });
  }

  getAllOrganizationAsync() {
    let url = localStorage.getItem('ApiEndPoint') + "/api/organization/getAllOrganizationForCustomer";
    return new Promise((resolve, reject) => {
      return this.httpClient.post(url, {}).toPromise()
        .then((response: Response) => {
          resolve(response);
        });
    });
  }

  //GetAllOrganizationByListId
  GetAllOrganizationByListId(organizationId: Array<string>) {
    let url = localStorage.getItem('ApiEndPoint') + "/api/organization/GetAllOrganizationByListId";
    return this.httpClient.post(url, { OrganizationId: organizationId})
      .map((response: Response) => {
        return response;
      });
  }

  createOrganization(organizationName: string,
    organizationCode: string,
    phone: string,
    address: string,
    level: Number,
    parentId: string,
    isFI: boolean) {
    let url = localStorage.getItem('ApiEndPoint') + "/api/organization/createOrganization";
    return this.httpClient.post(url, {
      OrganizationName: organizationName, OrganizationCode: organizationCode, Phone: phone,
      Address: address, Level: level, ParentId: parentId, IsFinancialIndependence: isFI
    })
      .map((response: Response) => {
        return response;
      });
  }

  getOrganizationById(orgId: string) {
    let url = localStorage.getItem('ApiEndPoint') + "/api/organization/getOrganizationById";
    return this.httpClient.post(url, { OrganizationId: orgId })
      .map((response: Response) => {
        return response;
      });
  }

  editOrganizationById(orgId: string, orgName: string, orgCode: string, orgPhone: string, orgAddress: string, isFI: boolean) {
    let url = localStorage.getItem('ApiEndPoint') + "/api/organization/editOrganizationById";
    return this.httpClient.post(url, {
      OrganizationId: orgId, OrganizationName: orgName, OrganizationCode: orgCode,
      Address: orgAddress, Phone: orgPhone, IsFinancialIndependence: isFI
    })
      .map((response: Response) => {
        return response;
      });
  }

  deleteOrganizationById(orgId: string) {
    let url = localStorage.getItem('ApiEndPoint') + "/api/organization/deleteOrganizationById";
    return this.httpClient.post(url, { OrganizationId: orgId })
      .map((response: Response) => {
        return response;
      });
  }

  getAllOrganizationCode() {
    let url = localStorage.getItem('ApiEndPoint') + "/api/organization/getAllOrganizationCode";
    return new Promise((resolve, reject) => {
      return this.httpClient.post(url, {}).toPromise()
        .then((response: Response) => {
          resolve(response);
        });
    });
  }

  getFinancialindependenceOrg() {
    let url = localStorage.getItem('ApiEndPoint') + "/api/organization/getFinancialindependenceOrg";
    return this.httpClient.post(url, {  })
      .map((response: Response) => {
        return response;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/organization.service.ts